import { classNames } from '@repo/ui/src/utils/classNames';

export interface SpinnerProps {
  className?: string;
}

const Spinner = ({ className }: SpinnerProps) => (
  <div role="status">
    <div
      className={classNames(
        'w-12 h-12 border-4 border-brand-300 border-t-transparent rounded-full animate-spin',
        className,
      )}
      aria-hidden="true"
    />
    <span className="sr-only">Loading</span>
  </div>
);

export default Spinner;
